const _import = (file) => require('module/' + file + '.vue').default;

export default [
  {
    path: '/login',
    alias: '/wp/app/login',
    component: _import('member/login/page'),
    props: (route) => ({ params: { ...route.query, ...route.params } }),
    meta: {
      canShare: true
    }
  },
  {
    path: '/download',
    alias: '/wp/app/download',
    component: _import('app/download/page'),
    props: (route) => ({ params: { ...route.query, ...route.params } }),
    meta: {
      canShare: true
    }
  },
  {
    path: '/:enterprise/login/result',
    component: _import('member/result/page'),
    props: (route) => ({ params: { ...route.query, ...route.params } }),
    meta: {
      auth: true
    }
  },
  {
    path: '/wp/app/gooddetail',
    component: _import('app/gooddetail/page'),
    props: (route) => ({ params: { ...route.query, ...route.params } })
  },
  {
    path: '/wp/app/protocol',
    component: _import('app/protocol/page'),
    props: (route) => ({ params: { ...route.query, ...route.params } })
  },
  {
    path: '/:enterprise/app/activity',
    component: _import('app/activityPage/page'),
    props: (route) => ({ params: { ...route.query, ...route.params } })
  },
  {
    path: '/:enterprise/app/privacy',
    component: _import('app/privacy/page'),
    props: (route) => ({ params: { ...route.query, ...route.params } })
  },
  {
    path: '/:enterprise/app/member/help',
    component: _import('app/member/page'),
    props: (route) => ({ params: { ...route.query, ...route.params } })
  },
  {
    path: '/:enterprise/coupons',
    component: _import('coupon/page'),
    props: (route) => ({ params: { ...route.query, ...route.params } })
  },
  {
    path: '/:enterprise/goods/:goodsId',
    component: _import('goods/detail/page'),
    props: (route) => ({ params: { ...route.query, ...route.params } }),
    meta: {
      auth: false,
      canShare: true
    }
  },
  {
    path: '/:enterprise/cart/settlement',
    component: _import('cart/settlement/page'),
    props: (route) => ({ params: { ...route.query, ...route.params } })
  },
  {
    path: '/cartpay', // 支付目录不允许动态
    component: _import('cart/pay/page'),
    props: (route) => ({ params: { ...route.query, ...route.params } }),
    meta: {
      auth: true,
      canShare: false,
      canPay: true
    }
  },
  {
    path: '/vippay', // 支付目录不允许动态
    component: _import('vip/pay/page'),
    props: (route) => ({ params: { ...route.query, ...route.params } }),
    meta: {
      auth: true,
      canShare: false,
      canPay: true
    }
  },
  {
    path: '/:enterprise/cart/paySuccess',
    component: _import('cart/paySuccess/page'),
    props: (route) => ({ params: { ...route.query, ...route.params } })
  },
  {
    path: '/:enterprise/vip/paySuccess',
    component: _import('vip/paySuccess/page'),
    props: (route) => ({ params: { ...route.query, ...route.params } })
  },
  {
    path: '/admin/summary',
    component: _import('summary/admin/page'),
    props: (route) => ({ params: { ...route.query, ...route.params } })
  },
  {
    path: '/__debug',
    component: _import('app/debug/page'),
    props: (route) => ({ params: { ...route.query, ...route.params } })
  },
  {
    path: '/yeepay/success',
    component: _import('app/paySuccess/page'),
    props: (route) => ({ params: { ...route.query, ...route.params } })
  },
  {
    path: '/__debug_webview',
    component: _import('app/jsBridge/page'),
    props: (route) => ({ params: { ...route.query, ...route.params } })
  },
  {
    path: '/guidelines',
    alias: '/wp/app/guidelines',
    component: _import('app/guidelines/page'),
    props: (route) => ({ params: { ...route.query, ...route.params } }),
    meta: {
      canShare: true
    }
  },
  {
    path: '/:enterprise/app/agreement',
    component: _import('app/agreement/page'),
    props: (route) => ({ params: { ...route.query, ...route.params } })
  },
  {
    path: '/wp/app/mergeAgreement',
    component: _import('app/mergeAgreement/page'),
    props: (route) => ({ params: { ...route.query, ...route.params } })
  },
  {
    path: '/wp/app/article/:id',
    component: _import('app/article/page'),
    props: (route) => ({ params: { ...route.query, ...route.params } })
  },
  {
    path: '/wp/app/videoList',
    component: _import('app/videoList/page'),
    props: (route) => ({ params: { ...route.query, ...route.params } })
  },
  {
    path: '/wp/app/video/:id',
    component: _import('app/video/page'),
    props: (route) => ({ params: { ...route.query, ...route.params } })
  },
  {
    path: '/wp/app/communityGroupVideo',
    component: _import('app/communityGroupVideo/page'),
    props: (route) => ({ params: { ...route.query, ...route.params } })
  },
  {
    path: '/wp/app/skinReport',
    component: _import('app/skinReport/page'),
    props: (route) => ({ params: { ...route.query, ...route.params } })
  },
  {
    path: '/wp/app/nursingContrast',
    component: _import('app/nursingContrast/page'),
    props: (route) => ({ params: { ...route.query, ...route.params } })
  },
  {
    path: '/wp/app/articleList',
    component: _import('app/articleList/page'),
    props: (route) => ({ params: { ...route.query, ...route.params } })
  },
  {
    path: '/wp/app/commentList/:id',
    component: _import('app/commentPage/page'),
    props: (route) => ({ params: { ...route.query, ...route.params } }),
    children: [
      { path: 'replyComment/:commId', component: _import('app/commentPage/page'), props: (route) => ({ params: { ...route.query, ...route.params } }) }
    ]
  },
  {
    path: '/:enterprise/app/coupon',
    component: _import('app/coupon/page'),
    props: (route) => ({ params: { ...route.query, ...route.params } })
  },
  {
    path: '/wp/app/earnMoneyRules',
    // alias: '/wp/app/earnMoneyRules',
    component: _import('app/earnMoneyRules/page')
  },
  {
    path: '/wp/app/fissionShareRules',
    // alias: '/wp/app/earnMoneyRules',
    component: _import('app/fissionShareRules/page')
  },
  {
    path: '/jump',
    component: _import('wechat/jump'),
    props: (route) => ({ params: { ...route.query, ...route.params } })
  },
  {
    path: '/app/meitu/redirect',
    component: _import('app/meituAuth/page'),
    props: (route) => ({ params: { ...route.query, ...route.params } })
  },
  {
    path: '/app/meitu/activity',
    component: _import('app/meituActivity/page'),
    props: (route) => ({ params: { ...route.query, ...route.params } })
  },
];



// WEBPACK FOOTER //
// ./src/router/routes.js